import { atom } from "recoil"
import uuid from "react-uuid"

const chatMessagesState = atom({
  key:'chatMessagesState',
  default:[{origin: 'system', msg: 'Hola, en esta seccion tendras actualizaciones ', id: uuid()}]
})

export default chatMessagesState